import GloveScript from "./glove-script";
import initGloveEventHandler from "./glove-data-event-handler";
import saveTestNamesToWindow from "./glove-active-tests";
export default function GloveScripts(abTests) {
    saveTestNamesToWindow(abTests);
    initGloveEventHandler();
    return GloveScript();
}
